import { render, staticRenderFns } from "./GrowItem.vue?vue&type=template&id=2ace9caa&scoped=true&"
import script from "./GrowItem.vue?vue&type=script&lang=js&"
export * from "./GrowItem.vue?vue&type=script&lang=js&"
import style0 from "./GrowItem.vue?vue&type=style&index=0&id=2ace9caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ace9caa",
  null
  
)

export default component.exports